import { AbstractSceneTransition } from "appworks/graphics/layers/scene-transitions/abstract-scene-transition";
import { Contract } from "appworks/utils/contracts/contract";
import { gameLayers } from "game-layers";

export class TGRHeaderTransition extends AbstractSceneTransition {

    public in(): Contract<void> {
        return Contract.wrap(() => {
            const topBar = document.getElementById("top-compliance-bar-pc");
            if (topBar) {
                gameLayers.Header.container.landscape.y = topBar.offsetHeight;
            }
        });
    }
}
